export default __webpack_public_path__ + "static/media/charlie-puth.6c47d73a.jpg";